import { apiClient } from "@/api/api-client";
import createBaseService from "@/api/base-service.ts";
import { z } from "zod";

const caseRecordStatisticService = {
	...createBaseService("/case-records/statistics"),
	getTotal: async (params = {}) => {
		const response = await apiClient.get<{ data: T[]; meta: Pagination }>("backoffice/case-records-total", { params });

		return response.data;
	},
	listByCourtType: async (params = {}) => {
		const response = await apiClient.get<{ data: T[]; meta: Pagination }>("/case-records/statistics-by-court-type", { params });

		return response.data;
	},
	listByBranch: async (params = {}) => {
		const response = await apiClient.get<{ data: T[]; meta: Pagination }>("/case-records/statistics-by-branch", { params });

		return response.data;
	},
	listByCategory: async (params = {}) => {
		const response = await apiClient.get<{ data: T[]; meta: Pagination }>("/case-records/statistics-by-category", { params });

		return response.data;
	},
	listByCaseType: async (params = {}) => {
		const response = await apiClient.get<{ data: T[]; meta: Pagination }>("/case-records/statistics-by-case-type", { params });

		return response.data.data;
	},
};

export default caseRecordStatisticService;
